// extracted by mini-css-extract-plugin
export default {"container":"exchange_container__h7KGS","row1":"exchange_row1__KD5SY","col1":"exchange_col1__haZnd","col2":"exchange_col2__lxjJH","marketContainer":"exchange_marketContainer__1kCjd"};